/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import { motion } from 'framer-motion';
import React, { useState, useEffect, useCallback } from 'react';
import { toast } from 'react-toastify';
import ThreeDotsLoader from '../LoadingDots';

function OtpScreen({
    Email, otpError, setotp, setotpError, handleOtp, inputfocus, otp, resendOtp, loading,setiniitialAuthentication
}) {
    const [timeLeft, setTimeLeft] = useState(60);
    const [enableReset, setEnablereset] = useState(false);

    // toast.configure();
    const handleResend = () => {
        resendOtp();
        setEnablereset(false);
        setTimeLeft(60);
    };

    function Countdown({ seconds }) {
        useEffect(() => {
            if (timeLeft >= 0) {
                const intervalId = setInterval(() => {
                    setTimeLeft((t) => t - 1);
                }, 1000);

                return () => clearInterval(intervalId);
            }
            setEnablereset(true);
            return (() => clearInterval(timeLeft));
        }, [timeLeft]);
        if (timeLeft >= 0) {
            return ` in ${timeLeft}`;
        }
    }

    return (
        <div className="flex">
            <div className="sm:flex-row flex-col relative flex h-custom w-full">        
                <div className="sm:w-[40%] w-full sm:opacity-100 opacity-50">
                    <img src="images/falcon_login_image.jpg" alt="icon" className="h-custom w-full object-fill" />
                </div>
                <div  className="sm:w-[60%] flex sm:flex-row flex-col justify-center items-center px-2 otp-login absolute sm:relative w-full sm:top-auto sm:-translate-y-0 -translate-y-1/2 top-1/2" >
                    <div className="sm:px-3 sm:py-0 p-6 bg-[#FFFFFF] sm:rounded-none rounded-lg" />
                    <div className=" lg:top-[30px] sm:pl-16 pl-6 absolute sm:-top-[100px] -top-[70px] left-0 ">
                        <a href="javascript:void(0)" className="flex items-center" onClick={()=>{
                            setotp({
                                one: '',
                                two: '',
                                three: '',
                                four: '',
                                five: '',
                                six: '',
                            })
                            setiniitialAuthentication(false)
                        }}>
                            <img src="images/Union24.svg" alt="icon" className="pr-1" />
                            Back
                        </a>
                    </div>
                    <motion.div
                        animate={{ y: 20 }}
                        transition={{ ease: 'backIn', duration: 1, type: 'spring' }} >
                        <form onSubmit={(e) => handleOtp(e)}>
                            <div className="login ">
                                <h5 className="md:text-xs1 text-center text-2xl font-bold text-[#555259] pb-3.5">Distributor Login</h5>
                                <p className="text-sm font-normal text-[#555259] pb-1 text-center">An OTP will be sent to your registered email address and mobile number</p>
                            </div>
                            <div className="digit-group flex justify-center sm:justify-end sm:mt-8 mt-6">
                                <label htmlFor="digit-1"></label>
                                <input
                                    type="number"
                                    className={`lg:w-10 md:w-8 w-6 sm:h-10 h-8 border-b-2 sm:mr-6 mr-5 bg-[transparent] outline-0 text-center md:text-xs1 text-2xl font-normal text-[#090406] otp-input err-otp ${otpError ? 'border-[#ED1C24]' : 'border-[#A9B2BE]'} `}
                                    name="digit-1"
                                    id="digit-1"
                                    data-next="digit-2"
                                    tabIndex="1"
                                    onChange={(e) => setotp((prevState) => ({
                                        ...prevState,
                                        one: e.target.value[0],
                                    }))}
                                    value={otp.one}
                                    maxLength="1"
                                    onFocus={() => setotpError(false)}
                                    onKeyUp={(e) => inputfocus(e)}
                                />
                                <label htmlFor="digit-2" />
                                <input
                                    type="number"
                                    className={`lg:w-10 md:w-8 w-6 sm:h-10 h-8 border-b-2 sm:mr-6 mr-5 bg-[transparent] outline-0 text-center md:text-xs1 text-2xl font-normal text-[#090406] otp-input err-otp ${otpError ? 'border-[#ED1C24]' : 'border-[#A9B2BE]'} `}
                                    name="digit-2"
                                    id="digit-2"
                                    maxLength="1"
                                    onFocus={() => setotpError(false)}               
                                    data-next="digit-3"
                                    tabIndex="2"
                                    data-previous="digit-1"
                                    onChange={(e) => setotp((prevState) => ({
                                        ...prevState,
                                        two: e.target.value[0],
                                    }))}
                                    value={otp.two}
                                    onKeyUp={(e) => inputfocus(e)}
                                />
                                <label htmlFor="digit-3" />
                                <input
                                    type="number"
                                    className={`lg:w-10 md:w-8 w-6 sm:h-10 h-8 border-b-2 sm:mr-6 mr-5 bg-[transparent] outline-0 text-center md:text-xs1 text-2xl font-normal text-[#090406] otp-input err-otp ${otpError ? 'border-[#ED1C24]' : 'border-[#A9B2BE]'} `}
                                    name="digit-3"
                                    maxLength="1"
                                    onFocus={() => setotpError(false)}
                                    id="digit-3"
                                    tabIndex="3"
                                    data-next="digit-4"
                                    data-previous="digit-2"
                                    onChange={(e) => setotp((prevState) => ({
                                        ...prevState,
                                        three: e.target.value[0],
                                    }))}
                                    value={otp.three}
                                    onKeyUp={(e) => inputfocus(e)}
                                />
                                <label htmlFor="digit-4" />
                                <input
                                    type="number"
                                    className={`lg:w-10 md:w-8 w-6 sm:h-10 h-8 border-b-2 sm:mr-6 mr-5 bg-[transparent] outline-0 text-center md:text-xs1 text-2xl font-normal text-[#090406] otp-input err-otp ${otpError ? 'border-[#ED1C24]' : 'border-[#A9B2BE]'} `}
                                    name="digit-4"
                                    id="digit-4"
                                    maxLength="1"
                                    onFocus={() => setotpError(false)}
                                    tabIndex="4"
                                    data-next="digit-5"
                                    data-previous="digit-4"
                                    onChange={(e) => setotp((prevState) => ({
                                        ...prevState,
                                        four: e.target.value[0],
                                    }))}
                                    value={otp.four}
                                    onKeyUp={(e) => inputfocus(e)}
                                />
                                <label htmlFor="digit-5" />
                                <input
                                    type="number"
                                    className={`lg:w-10 md:w-8 w-6 sm:h-10 h-8 border-b-2 sm:mr-6 mr-5 bg-[transparent] outline-0 text-center md:text-xs1 text-2xl font-normal text-[#090406] otp-input err-otp ${otpError ? 'border-[#ED1C24]' : 'border-[#A9B2BE]'} `}
                                    name="digit-5"
                                    id="digit-5"
                                    data-next="digit-6"
                                    tabIndex="5"
                                    maxLength="1"
                                    onFocus={() => setotpError(false)}
                                    data-previous="digit-4"
                                    onChange={(e) => setotp((prevState) => ({
                                        ...prevState,
                                        five: e.target.value[0],
                                    }))}
                                    value={otp.five}
                                    onKeyUp={(e) => inputfocus(e)}
                                />
                                {' '}
                                <label htmlFor="digit-6" />
                                {/* <!-- If it is a error state then border color will be "#ED1C24" --> */}
                                <input
                                    type="number"
                                    className={`lg:w-10 md:w-8 w-6 sm:h-10 h-8 border-b-2 sm:mr-6 mr-5 bg-[transparent] outline-0 text-center md:text-xs1 text-2xl font-normal text-[#090406] otp-input err-otp ${otpError ? 'border-[#ED1C24]' : 'border-[#A9B2BE]'} `}
                                    name="digit-6"
                                    tabIndex="6"
                                    id="digit-6"
                                    data-next="digit-7"
                                    maxLength="1"
                                    onFocus={() => setotpError(false)}
                                    data-previous="digit-5"
                                    onChange={(e) => setotp((prevState) => ({
                                        ...prevState,
                                        six: e.target.value[0],
                                    }))}
                                    value={otp.six}
                                    onKeyUp={(e) => inputfocus(e)}
                                />
                                {' '}

                            </div>
                            {otpError && (
                                <motion.p
                                    animate={{ y: 10 }}
                                    transition={{ ease: 'backIn', duration: 1, type: 'spring' }}
                                    className="text-sm font-normal text-[#ED1C24] pt-3.5 text-center wrong-password"
                                >
                                    Incorrect OTP! Please try again.
                                </motion.p>
                            )}
                            <div>
                                {!enableReset ? <p className="text-sm font-normal text-[#555259] pt-9 text-center cursor-pointer pb-[18px] resend-otp">Resend OTP <Countdown seconds={30} /> sec</p>
                                    :<div className="pt-5 pb-3 flex justify-center resend">
                                        <button type='button' className="cursor-pointer text-sm font-bold text-[#090406]" id="resend-button" onClick={()=>handleResend()}>Resend OTP</button>
                                    </div>}
                               
                                <div className="flex justify-center relative login-btn1">
                                    <button disabled={loading} type="submit"  className="md:w-[316px] w-[250px] md:h-[52px] h-9 text-center bg-[#555259] rounded-2xl text-lg font-semibold text-[#FFFFFF] hover:bg-[#808285] transition hover:-translate-x-1">
                                        Login                                  </button>
                                    {loading && <div className="loader bg-[#FFFFFF] rounded-lg shadow-s2 absolute -top-[138px] left-1/2 -translate-x-1/2 px-7 pt-6 pb-3 min-h-[108px] min-w-[108px]">
                                        <lottie-player src="https://assets8.lottiefiles.com/packages/lf20_c0b34ayt.json" class="" background="transparent"  speed="1" style={{width:'58px',height:'58px'}}  loop  autoplay ></lottie-player>
                                        <p className="text-sm font-normal text-[#555259] text-center">Loading..</p>
                                    </div>}
                                </div>
                            </div>
                        </form>
                    </motion.div>
                </div>
            </div>
        </div>
    );
}

export default OtpScreen;
